export default __webpack_public_path__ + "static/media/minimize.6a2fb4a3.svg";